import { apiCall, ApiResponse } from "./apiClient";
import { TransportListItem, TransportOrTransportPlan } from "../models/transport/transport";
import { TransportDetails, TransportState, TransportTaskType } from "../models/transport/transport";

// TORM: Is this needed anymore?

export const updateTransportState = (id: string, newState: TransportState): Promise<ApiResponse<void>> => {
    return apiCall<void>(`Transports/${id}/State/${newState}`, "PUT");
};

interface TransportFilters {
    state?: TransportState;
    employeeId?: string;
}

export const fetchTransports = (filters: TransportFilters): Promise<ApiResponse<TransportListItem[]>> => {
    return apiCall<TransportListItem[]>("Transports", "GET", filters);
};

export const fetchTransport = (id: string): Promise<ApiResponse<TransportDetails>> => {
    return apiCall<TransportDetails>(`Transports/${id}`, "GET");
};

export const createTransportTask = (transportId: string, transportOrderId: string, taskType: TransportTaskType): Promise<ApiResponse<void>> => {
    return apiCall<void>(`Transports/${transportId}/TransportTasks`, "POST", { transportOrderId, taskType });
};

export const transportToCommonTransportModel = (data: TransportListItem) : TransportOrTransportPlan => {
    return {
        transportId: data.id,
        transportPlanId: data.transportPlan.id,
        name: data.transportPlan.name,
        transportState: data.state,
        transportPlanState: data.transportPlan.state,
        orders: data.transportPlan.orders,
        employee: data.employee,
        vehicle: data.vehicle,
        plan: data.transportPlan,
        startDateTime: data.startDateTime,
        endDateTime: data.endDateTime,
        isPlan: false,
    };
};
